// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4543":"css/app.6988","7735":"css/admin-app.6988"}[chunkId] + ".css";
};